<div mat-dialog-title class="modal-header">
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">history</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Histórico de Buscas Sefaz</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()" aria-label="Fechar histórico">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="filtros-historico">
    <mat-form-field appearance="outline" class="filtro-empresa">
      <mat-label>Empresa</mat-label>
      <mat-select [formControl]="empresaSelectControl">
        <mat-select-trigger>
          {{ getSelectedEmpresaName() }}
        </mat-select-trigger>
        @for (empresa of listaEmpresas; track empresa.idEmpresa) {
        <mat-option [value]="empresa.idEmpresa">
          <div class="d-flex align-items-center justify-content-between w-100 gap-2">
            <span>{{ empresa.nomeEmpresa }}</span>
            @if (!empresa.certificadoValido) {
            <mat-icon class="text-warning" matTooltip="Certificado A1 inválido ou ausente">warning</mat-icon>
            }
          </div>
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <app-select-pesquisavel
      class="filtro-modelo"
      label="Modelo do documento"
      [control]="modeloDocumentoControl"
      [idField]="'idModeloDocumento'"
      [nameField]="'nome'"
      [subtitleFields]="['descricao']"
      [offlineList]="listaModeloDocumento"
      [multiple]="true"
      [isOptional]="true"
      hint="Selecione os modelos">
    </app-select-pesquisavel>
  </div>

  <div class="d-flex flex-column flex-sm-row justify-content-end align-items-sm-center gap-3 mb-3">

    <div>
      <mat-checkbox [(ngModel)]="isReiniciarNsu"
        [disabled]="botaoBuscaDesabilitado || isLoadingPedido || isLoadingLogs || isLoadingMais"
        matTooltipPosition="above"
        matTooltip="Ao marcar essa opção a solicitação de busca manual será feita do início, bucando TODOS os documentos dos últomos 3 mêses (Uso avançado)">
        Buscar documentos do incío
      </mat-checkbox>
    </div>

    <span class="tooltip-wrapper d-inline-block" [matTooltip]="tooltipMensagem" matTooltipPosition="above">
      <button mat-flat-button class="btn-primary" (click)="solicitarBuscaManual()"
        [disabled]="botaoBuscaDesabilitado || isLoadingPedido || isLoadingLogs || isLoadingMais">

        @if (isLoadingPedido) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">document_search</span>
        <span>Solicitar Busca Manual</span>
        }
      </button>
    </span>
  </div>

  @if (isLoadingLogs) {
  <app-loading-box-default-list></app-loading-box-default-list>
  }

  @if (!isLoadingLogs && dataSource.data.length > 0) {
  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource" class="w-100">

      <ng-container matColumnDef="dataHora">
        <th mat-header-cell *matHeaderCellDef> Data/Hora </th>
        <td mat-cell *matCellDef="let log" class="text-nowrap"> {{ log.datetimeInclusao | date:'dd/MM/yy HH:mm:ss' }} </td>
      </ng-container>

      <ng-container matColumnDef="modelo">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Modelo </th>
        <td mat-cell *matCellDef="let log" class="text-center text-nowrap"> {{ obterDescricaoModelo(log) }} </td>
      </ng-container>

      <ng-container matColumnDef="origem">
        <th mat-header-cell *matHeaderCellDef> Origem </th>
        <td mat-cell *matCellDef="let log" class="text-nowrap"> {{ obterDescricaoOrigem(log) }} </td>
      </ng-container>

      <ng-container matColumnDef="codigo">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Código </th>
        <td mat-cell *matCellDef="let log" class="text-center"> {{ log.codigoRetornoSefaz || 'N/A' }} </td>
      </ng-container>

      <ng-container matColumnDef="mensagem">
        <th mat-header-cell *matHeaderCellDef> Mensagem </th>
        <td mat-cell *matCellDef="let log">
          <div [matTooltip]="log.mensagemRetornoSefaz">
            {{ log.mensagemRetornoSefaz}}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="qtdDocs">
        <th mat-header-cell *matHeaderCellDef class="text-center"> Docs. </th>
        <td mat-cell *matCellDef="let log" class="text-center"> {{ log.quantidadeDocumentosRetornados }} </td>
      </ng-container>
      <ng-container matColumnDef="nsuConsultado">
        <th mat-header-cell *matHeaderCellDef class="text-center"> NSU </th>
        <td mat-cell *matCellDef="let log" class="text-center"> {{ log.nsuConsultado || 'N/A' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  @if(!ultimaPagina) {
  <div class="d-flex justify-content-center mt-3">
    <button mat-button (click)="proximaPagina()" [disabled]="isLoadingMais">
      @if (isLoadingMais) {
      <mat-spinner [diameter]="20"></mat-spinner>
      } @else {
      <span class="material-symbols-outlined">keyboard_arrow_down</span>
      <span>Ver mais</span>
      }
    </button>
  </div>
  }

  } @else if (!isLoadingLogs && dataSource.data.length === 0) {
  <app-empty-list [smallImg]="true" title="Nenhum histórico encontrado">
  </app-empty-list>
  }

</mat-dialog-content>
